import React from 'react';
import { useTheme } from '../../hooks/useTheme';
import Icon from '../AppIcon';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  
  return (
    <button
      onClick={toggleTheme}
      className={`p-2 rounded-md transition-colors hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring ${className}`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <Icon 
        name={theme === 'light' ? 'Moon' : 'Sun'} 
        size={16} 
        className={`text-muted-foreground hover:text-foreground transition-colors ${
          theme === 'dark' ? 'text-yellow-500' : ''
        }`}
      />
    </button>
  );
};

export default ThemeToggle;